export interface ScreenRect {
  readonly left: number;
  readonly top: number;
  readonly width: number;
  readonly height: number;
}

/**
 * キャンバス上のオブジェクト本体要素を、共有する DOM 契約から取得する。
 *
 * オブジェクト ID はサーバスキーマが長さだけを制限しており、引用符・`]`・空白などを含み得る。
 * そのままセレクタへ補間すると querySelector が例外を投げ、呼び出し側の処理全体が止まるため、
 * 必ず CSS.escape を通す（英数字だけの通常の ID では恒等であり挙動は変わらない）。
 */
export function findCanvasObjectElement<T extends Element = Element>(objectId: string): T | null {
  return document.querySelector<T>(`[data-testid="canvas-object-${CSS.escape(objectId)}"]`);
}

/** 選択中オブジェクトの実描画矩形を、クライアント座標で union して返す。 */
export function readSelectionScreenRect(objectIds: readonly string[]): ScreenRect | null {
  let left = Number.POSITIVE_INFINITY;
  let top = Number.POSITIVE_INFINITY;
  let right = Number.NEGATIVE_INFINITY;
  let bottom = Number.NEGATIVE_INFINITY;
  let found = false;

  for (const objectId of objectIds) {
    const element = findCanvasObjectElement(objectId);
    if (!element) continue;
    const rect = element.getBoundingClientRect();
    left = Math.min(left, rect.left);
    top = Math.min(top, rect.top);
    right = Math.max(right, rect.right);
    bottom = Math.max(bottom, rect.bottom);
    found = true;
  }

  return found ? { left, top, width: right - left, height: bottom - top } : null;
}
